import Model from 'flarum/common/Model';
export default class Language extends Model {
  code() {
    return Model.attribute('code').call(this);
  }
  country() {
    return Model.attribute('country').call(this);
  }
  name() {
    return Model.attribute('name').call(this);
  }
  emoji() {
    return Model.attribute('emoji').call(this);
  }
}
flarum.reg.add('fof-discussion-language', 'common/models/Language', Language);